export const environment = {
    production: false,
    url: "https://api-tmim.policystreet.app/api",
};
